export const TEXTS = {
    CLAIM: "CLAIM",
    FREE: "FREE",
};


export const FREEBIE_ITEM_IMAGE_SIZE = {
    WIDTH: 64,
    HEIGHT: 64,
};

export const FREEBIE_ITEM_IMAGE_SIZE_V2 = {
    WIDTH: 44,
    HEIGHT: 64,
};